import React from 'react';
import icons from '../../assets/icons';
import SearchBox from '../searchBox';
import CustomButton from '../customButton';
import './styles.scss';

const ToolBar = ({
  title,
  count,
  icon,
  hasButton,
  hasMultipleButtons = false,
  buttonsList = [],
  buttonTitle,
  buttonPress,
  searchPlaceholder,
  onSearch,
  renderFilters,
  searchingBy,
  customOptions,
  disabledButton = false,
  buttonTooltip = null
}) => {
  return (
    <div className="toolbar">
      <div className="d-flex flex-fill">
        <div className="title">
          <img src={icons[icon]} alt={title} />
          <h2>{title}</h2>
        </div>
        {count !== undefined && count !== null && <div className="count">{count} total</div>}
        {onSearch && (
          <SearchBox
            searchingBy={searchingBy}
            onChange={onSearch}
            placeholder={searchPlaceholder ? searchPlaceholder : 'Search'}
          />
        )}
        {renderFilters}
      </div>
      {customOptions}
      <div className="toolbar-buttons">
        {hasButton && (
          <CustomButton
            title={buttonTitle}
            classes={'btn-primary'}
            handleClick={buttonPress}
            disabled={disabledButton}
            tooltip={buttonTooltip}
          />
        )}
        {hasMultipleButtons &&
          buttonsList &&
          buttonsList.map((button, index) => (
            <CustomButton
              key={index}
              title={button.title}
              classes={button.classes}
              handleClick={button.handleClick}
              disabled={button.disabled}
              loading={button.loading}
              tooltip={button.tooltip}
            />
          ))}
      </div>
    </div>
  );
};

export default ToolBar;
